import { Component, OnInit, Input, Inject, } from '@angular/core';
import { CommonService } from '../../shared/core/services/common.service';
import { StorageService } from '../../shared/core/services/storage.service';
import { Users } from '../../manage/users/users';
import { CustomerContacts } from '../../manage/customerContacts/customerContacts';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.css'],
})
export class LeftMenuComponent{

  icon: boolean = false;
  customCollapsedHeight: string = '50px';
  customExpandedHeight: string = '50px';

  // customCollapsedHeight: string = 'auto';
  // customExpandedHeight: string = 'auto';

  isShow :boolean;
  IsExpanded1 :boolean;
  IsExpanded2 :boolean;
  IsExpanded3 :boolean;
  IsExpandedT :boolean;
  IsExpanded4 :boolean;
  IsExpandedTask: boolean;
  IsExpandedAlgo: boolean;
  user_id: number;
  user: Users;
  company_name: string;
  avatar_url = 'assets/img/user.png';
  customerContact: CustomerContacts;
  IsExpandedReports: boolean;
  IsExpandedTrip: boolean;
  panelOpenState = false;
  IsExpandedTripRequests = false;
  displayIcon:boolean;
  isInternalErp = false;
  constructor(private commonService:CommonService,
    @Inject(DOCUMENT) private document: Document
    ){
    //
    this.displayIcon = false;
    this.checkIfInternalErp();
  }
  setUserParameters() {
    this.user = StorageService.getUser();
    this.user_id = (this.user && this.user!= null) ? this.user.id : 0;
    if(this.user  && this.user!= null) {
      if(this.user.avatar_location) {
        this.avatar_url = this.user.avatar_location;
      }
      else{
        this.avatar_url = 'https://ui-avatars.com/api/?rounded=true&name=' + this.user.name;
      }

    }
    this.company_name = StorageService.getItem('company_name');
    if(this.user && this.user!= null && (!this.company_name) || this.company_name == null){
      if(this.user.work_area_cd && this.user.work_area_cd[0]){
        this.company_name = this.user.work_area_cd[0];
      }
    }

    this.commonService.castLogin$.subscribe(isShow=>{
      setTimeout(()=>{
        this.isShow = isShow;
      });
    });
  }
  ngOnInit() {
    //
    this.setUserParameters();
  }
  checkIfInternalErp(){
    StorageService.isInternalErp$.subscribe(value => {
      this.isInternalErp = value;
    });
  }
  toggle1() {
    this.IsExpanded1 = !this.IsExpanded1;
   }
   toggle2() {
    this.IsExpanded2 = !this.IsExpanded2;
   }
   toggle3() {
    this.IsExpanded3 = !this.IsExpanded3;
   }
   toggleT() {
    this.IsExpandedT = !this.IsExpandedT;
   }
   toggle4() {
    this.IsExpanded4 = !this.IsExpanded4;
   }
   toggleReport(anEvent){
     anEvent.preventDefault();
     this.IsExpandedReports = !this.IsExpandedReports;
   }
   checkRole(arr){
     return StorageService.checkRole(arr);
   }
   userIsLE(){
     return StorageService.userIsLE();
   }
   userIsTacking(){
    return StorageService.userIsCT();
  }
  toggleDrawer(){
    localStorage.setItem('selectedMenu', "dummy Name");
    this.commonService.toggle();
    //
  }
  checkWA(workAreaCd: string){
    return StorageService.checkWA(workAreaCd);
  }
}


